import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { UnitOfMeasurement, UnitOfMeasurementCreateDTO } from '../interfaces/unit-of-measurement.interface';
import { AuthService } from './auth.service';

export const UnitOfMeasurementService = {
    getAll: async (): Promise<UnitOfMeasurement[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        const params = institutionId ? `?institutionId=${institutionId}` : '';
        const response = await axios.get(`${ENDPOINTS.UNIT_OF_MEASUREMENT.ALL}${params}`);
        return response.data;
    },

    create: async (dto: UnitOfMeasurementCreateDTO): Promise<UnitOfMeasurement> => {
        const response = await axios.post(ENDPOINTS.UNIT_OF_MEASUREMENT.ALL, dto);
        return response.data;
    },

    update: async (id: string, dto: UnitOfMeasurementCreateDTO): Promise<UnitOfMeasurement> => {
        const response = await axios.put(ENDPOINTS.UNIT_OF_MEASUREMENT.BY_ID(id), dto);
        return response.data;
    },

    delete: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.UNIT_OF_MEASUREMENT.BY_ID(id));
    },
};
